/**
 * @flow
 * @relayHash c7a59e51a820763818050343e20a54ca
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CategoryEditor_category$ref = any;
export type queries_categoryQuery_QueryVariables = {|
  id: string
|};
export type queries_categoryQuery_QueryResponse = {|
  +category: ?{|
    +$fragmentRefs: CategoryEditor_category$ref
  |}
|};
export type queries_categoryQuery_Query = {|
  variables: queries_categoryQuery_QueryVariables,
  response: queries_categoryQuery_QueryResponse,
|};
*/


/*
query queries_categoryQuery_Query(
  $id: ID!
) {
  category: node(id: $id) {
    __typename
    ...CategoryEditor_category
    id
  }
}

fragment CategoryEditor_category on Category {
  id
  name
  slug
  hidden
  section
  seoTitle
  seoDescription
  seoKeywords
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_categoryQuery_Query",
  "id": null,
  "text": "query queries_categoryQuery_Query(\n  $id: ID!\n) {\n  category: node(id: $id) {\n    __typename\n    ...CategoryEditor_category\n    id\n  }\n}\n\nfragment CategoryEditor_category on Category {\n  id\n  name\n  slug\n  hidden\n  section\n  seoTitle\n  seoDescription\n  seoKeywords\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_categoryQuery_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "category",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CategoryEditor_category",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_categoryQuery_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "category",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "type": "Category",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hidden",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "section",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoTitle",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoDescription",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoKeywords",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ede4b7182f64f8ecf8f3c33034f894a2';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_categoryQuery_Query.graphql.js